export enum PersonAndPersonType {
    Accomplice = 1,
    Acquaintance = 2,
    AdoptedChild = 3,
    Aunt = 4,
    AuthorityFigure = 5,
    BailBondPoster = 6,
    BabySitter = 7,
    BabySittee = 8,
    Boyfriend = 9,
    CareGiver = 10,
    CellMate = 11,
    Child = 12,
    ChildOfBoyfriendGirlfriend = 13,
    CivilUnion = 14,
    Client = 15,
    Cohabitant = 16,
    Contact = 17,
    Cousin = 18,
    CoWorker = 19,
    DeliveryPerson = 20,
    DomesticPartner = 21,
    EmergencyContact = 22,
    Employee = 23,
    Employer = 24,
    PreviousRomanticType = 25,
    ExSpouse = 26,
    FamilyMember = 27,
    FinancialSupporter = 28,
    FosterChild = 29,
    FosterParent = 30,
    FormerEmployee = 31,
    Friend = 32,
    Girlfriend = 33,
    Grandchild = 34,
    Grandparent = 35,
    InLaw = 36,
    IntimatePartner = 37,
    LastSeenBy = 38,
    Neighbor = 39,
    Nephew = 40,
    Niece = 41,
    NextOfKin = 42,
    Parent = 43,
    Partner = 44,
    Patient = 45,
    Sibling = 46,
    Spouse = 47,
    SpouseCommonLaw = 48,
    Student = 49,
    StepParent = 50,
    StepChild = 51,
    Stranger = 52,
    Teacher = 53,
    Uncle = 54,
    UnknownType = 55,
    Victim = 56,
    VictimWasOffender = 57,
    Visitor = 58,
    OnVisitorLog = 59,
    Witness = 60,
    AdultRecord = 61,
    JuvenileRecord = 62,
    Enemy = 63
  }
  